import { useTranslation } from 'react-i18next';
import { getToilTimeAdjustmentUrl } from '@/constant/approval';
import type { ContentExtraProps } from '../../types';
import InfoTable from '@/components/Approval/@components/InfoTable';
import useAttendanceDetail from './useAttendanceDetail';
import {
  formatCountOfLimit,
  formatHours,
  formatPeriod,
  formatWorkingHoursRange,
} from './format';
import { AttendanceSlotRoot } from './styles';
import type { ToilTimeAdjustmentDetail } from './types';

/** 224 (신규)연장근무 적립 사용 */
const ToilTimeUseSlot = ({ data }: ContentExtraProps) => {
  const { t } = useTranslation();
  const { cell } = useAttendanceDetail<ToilTimeAdjustmentDetail>(
    getToilTimeAdjustmentUrl(data.documentId),
  );

  return (
    <AttendanceSlotRoot>
      <InfoTable
        title={t('신청자 정보')}
        rows={[
          {
            label: t('근무시간'),
            value: cell((d) =>
              formatWorkingHoursRange(d.toilTimeAdjustment?.workingHours),
            ),
          },
        ]}
      />
      <InfoTable
        title={t('신청 내용')}
        rows={[
          { label: t('구분'), value: t('연장근무 적립 사용') },
          {
            label: t('신청 기간'),
            value: cell((d) =>
              formatPeriod(
                d.toilTimeAdjustment?.startedAt,
                d.toilTimeAdjustment?.endedAt,
              ),
            ),
          },
          {
            label: t('사용 시간'),
            value: cell((d) => formatHours(d.toilTimeAdjustment?.usedHours, t)),
            emphasis: true,
          },
        ]}
      />
      <InfoTable
        title={t('연장근무 사용 현황')}
        rows={[
          {
            label: t('이번주 신청 횟수'),
            value: cell((d) =>
              formatCountOfLimit(d.weeklyRequestCount, d.weeklyLimit, t),
            ),
          },
          {
            label: t('사용 가능 시간'),
            value: cell((d) => formatHours(d.remainingHours, t)),
          },
        ]}
      />
    </AttendanceSlotRoot>
  );
};

export default ToilTimeUseSlot;
